import { getProductTailored } from '@libs/api-proxy-client';
import { logSentryError } from '@libs/common-next';
import { logger, tryCatch } from '@libs/core';

import { SentryErrors } from '@/shared/sentry';

import type { CustomAddress, DeliveryMethodType, TailoredApiResponse } from './dto';
import { mapTailoredData } from './mapper';

type FetchProductTailored = {
    deliveryMethodsList: DeliveryMethodType[];
    storeId?: string;
    customAddress?: CustomAddress;
    variantSkus: string[];
};

export const fetchProductTailored = async ({
    deliveryMethodsList,
    storeId,
    customAddress,
    variantSkus = [],
}: FetchProductTailored) => {
    const [error, result] = await tryCatch(
        getProductTailored<TailoredApiResponse>({
            storeId,
            customAddress,
            deliveryMethodsToRetrieve: deliveryMethodsList,
            variantSkus,
        })
    );

    if (error) {
        logger.error('[FETCH TAILORED][Error]: %o', error);
        logSentryError(error, SentryErrors.ProductTailoredAPI.FetchProductTailoredFailed);
        throw error;
    }

    return mapTailoredData({ data: result.data });
};
